import { IndexGenerator } from 'fractional-indexing-jittered';

export const defaultOrder = 'a0';

export const defaultGroup = 'g00'; // 2 digits to eventually support more than 10 phases

export const defaultGroupOrder = `${defaultGroup}${defaultOrder}`;

const generatedIndexGroupIdLength = 3;

interface Orderable {
  order: string;
  id: string;
}

export function orderableCompareFn(a: Orderable, b: Orderable): number {
  if (a.order < b.order) return -1;
  if (a.order > b.order) return 1;
  if (a.id < b.id) return -1;
  if (a.id > b.id) return 1;
  return 0;
}

export function getGroupFromOrder(order: string) {
  return order.substring(0, generatedIndexGroupIdLength);
}

export function getGroupNumberFromOrder(order: string): number {
  return parseInt(order.substring(1, generatedIndexGroupIdLength), 10);
}

export function getPinOrderGenerator(orders: string[]): IndexGenerator {
  // TODO: do we need to sort the orders always, should improve
  const sorted = [...orders].sort();
  return new IndexGenerator(sorted, { groupIdLength: generatedIndexGroupIdLength, useJitter: true });
}
